import React from "react";
import {
  Container,
} from "react-bootstrap";
import "./Channels.scss";
import SurgirButton from '../../components/ui/SurgirButton/SurgirButton';

import Interbank from "./../../assets/images/InterbankChannels.svg";
import KasNet from "./../../assets/images/KasNet SURGIR.svg";

import BCP from "./../../assets/images/BBVA.png";
import YAPE from "./../../assets/images/PICHINCHA.png";
import YAPE2 from "./../../assets/images/YAPE SURGIR 2.svg";
import BanBif from "./../../assets/images/BanBif SURGIR.svg";
import InterbankAccordion from './../../assets/images/channels/InterbankLogo.svg'
import KasnetAccordion from './../../assets/images/channels/KasNetLogo.svg'

import BCPAccordion from './../../assets/images/channels/BCPLogo.svg'
import BanBifAccordion from './../../assets/images/channels/BanBifLogo.svg'
import { ReactComponent as Negocio } from "./../../assets/images/IconBusiness.svg";
import { ReactComponent as Computadora } from "./../../assets/images/IconComputadora.svg";
import { ReactComponent as Billetera } from "./../../assets/images/Icons - Banking - ic_wallet_digital.svg"
import { ReactComponent as Desembolsos } from "./../../assets/images/IconDesembolsos.svg";
import { ReactComponent as Oficina } from "./../../assets/images/IconOficina.svg";
import BannerDesktop from '../../assets/images/canal-abierto.png'

import BannerTablet from "./../../assets/images/Canal Abierto.jpg";
import BannerMobile from "./../../assets/images/Canal Abierto.jpg";



import AccordionChannelsSurgir from "./components/AccordionChannelsSurgir/AccordionChannelsSurgir"
import IconChevronUpWhite from "./../../assets/images/channels/chevron-up-white.svg"
import { padding } from "@mui/system";
const redirectAuto = () => {
  window.location.href = 'https://secure.ethicspoint.eu/domain/media/es/gui/114049/index.html'
}

const Channels: React.FC<any> = () => {
  return (
    <div>

      <div className="boxi-c" >
        <Container>
          <div className="canal-abierto-container-banner" >
            <div className="canal-abierto-container-text">
              <span className="canal-abierto-text-banner" > Canal abierto <br /> <span style={{ color: "red" }}>de denuncias</span><br />
                <span className="canal-abierto-subText-banner">Denuncia cualquier situación que atente contra nuestros valores. Estamos contigo.</span>
              </span>
            </div>
            <div>
              <img className="canal-abierto-image" src={BannerDesktop} alt="Banner Donde Estamos" />
            </div>
          </div>
        </Container>

      </div>
      <Container>
        <div className="canales-digitales" style={{ padding: "0px  10%" }}>
          <div
            className="canales-digitales__header"
          >
            <span className="canales-digitales__header__title">
              Canal Abierto de Denuncias
            </span>
            <br />



          </div>



          <Container>


            <span className="parrafo">
              En Santander Empresa Administradora de Fondos Colectivos abogamos por una cultura abierta y honesta para que todos se sientan libres a la hora de expresarse. Nuestro objetivo es garantizar que avanzamos como una empresa donde hacemos las cosas de manera Sencilla, Personal, y Justa, al tiempo que cumplimos con la regulación vigente y con nuestra normativa interna.
              <br />
              Para asegurar que así es, te invitamos a visitar Canal Abierto, nuestra plataforma de denuncias, una vía para que cualquier persona relacionada con Santander Empresa Administradora de Fondos Colectivos, pueda comunicar de forma anónima y confidencial, irregularidades financieras y contables. Además, con este canal se facilita la comunicación de incumplimientos regulatorios y del sistema de gobierno interno de nuestra entidad.
              <br />
              Canal Abierto también es la vía para comunicar aquellas conductas que no se encuentren alineadas con nuestro Código General de Conducta (CGC) o con nuestros comportamientos corporativos.
              <br /><br />
              <strong>
                ¿Quieres comunicarnos algo?</strong>
              <br />
              El Canal Abierto es una plataforma a la que se puede acceder vía web y que está operativa las 24 horas al día todos días de la semana.
              Es una parte esencial de la política de transparencia de nuestro Grupo. Se trata de un canal eficaz en nuestra transformación cultural, que contribuye a la constitución de una empresa abierta y honesta con la que se puede hablar claro y donde todos son escuchados de verdad.
              <br />
              Si tienes conocimiento de alguna conducta que nos aleje de ser una entidad ética, responsable y justo, levanta la mano y comunica. #tuconductaimporta
              <br />
              
              <center>
                <SurgirButton
                  onClick={redirectAuto}
                  radius={'32px'}
                  fontFamily={"SantanderTextW05-Bold"}
                  width='170px'
                  height='40px'
                  marginTop="30px"
                  variant="danger"
               
                >
                  Canal abierto
                </SurgirButton>
              </center>
             
              <br />
              Este formulario es utilizado únicamente para realizar consultas y denuncias referidas a casos que nos alejen de ser una entidad ética, responsable y justa, por ello, no se encuentra habilitada para recibir mensajes sobre otros temas. En caso necesite realizar una consulta, requerimiento, sugerencia, queja o reclamo puede ingresarlo desde nuestro <a
                href="https://www.santanderfondoscolectivos.com.pe/reclamos-y-requerimientos "
                rel="noopener noreferrer"
                style={{ color: "#257fa4" }}
              >
                Libro de Reclamaciones

              </a> o puede llamar a la central telefónica <a
                href="tel: (01) 730-1077
 "
                rel="noopener noreferrer"
                style={{ color: "#257fa4" }}
              >
                (01) 730-1077

              </a>- opción 1 (consultas, requerimientos o sugerencias), opción 2 (cobranzas) y opción 4 (quejas o reclamos)
            </span>

          </Container>
          <br /><br /><br /><br />
        </div>

      </Container>

    </div>



  );
}

export default Channels;
